// extracted by mini-css-extract-plugin
export default {"container":"ProgressDonut_container__57Gq3","arc":"ProgressDonut_arc__f6smP","circle":"ProgressDonut_circle__CaEiP"};